<script>
export default {
  methods: {
    validateState() {
      const isUSA = this.$refs.country?.validate && this.fields.country?.id === this.countryUsa.id;
      // only set error if USA selected
      this.$nextTick(() => {
        if (!this.$refs.userState?.validate && isUSA) {
          this.$set(
            this.errors,
            'user_state',
            'Please enter a valid state.',
          );
        } else {
          this.$delete(this.errors, 'user_state');
        }
      });
    },
  },
};
</script>
